import React, {Component} from 'react'
import {Link} from 'react-router-dom'

import Header from "../components/Header";
import Footer from '../components/Footer'

const Privacy = () => (
    <div>
        <Header/>
        <div className="content partslist-page">
            <div className="container">
                <div className="pb-5">
                    <h1 className="title-partslist-page">プライバシーポリシー</h1>
                    <div className="img-three-dot">
                        <img src="images/three-dot.png" className="img-fluid"/>
                    </div>
                    <div className="description-item-parts">
                        株式会社dscは、 個人情報保護の重要性に鑑み、「個人情報の保護に関する法律」及び本プライバシーポリシーを遵守し、お客さまのプライバシー保護に努めます。
                    </div>
                    <h2 className="h2-tag-parts">
                        <img src="images/icon_03.png" className="img-fluid mr-3"/>
                        <span>個人情報の定義</span>
                    </h2>
                    <div className="description-item-parts">
                        お客さま個人に関する情報(以下「個人情報」といいます)であって、お客さまのお名前、住所、電話番号など当該お客さま個人を識別することができる情報をさします。他の情報と組み合わせて照合することにより個人を識別することができる情報も含まれます。
                    </div>
                    <h2 className="h2-tag-parts">
                        <img src="images/icon_03.png" className="img-fluid mr-3"/>
                        <span>１．収集・利用</span>
                    </h2>
                    <div className="description-item-parts">
                        弊社は、お客さまからご提供いただいた個人情報を、ご提供いただく際にお客さまにお知らせした利用目的の範囲内で利用します。但し、弊社の商品開発及びマーケティング活動のために利用させていただくことがあります。
                    </div>
                    <h2 className="h2-tag-parts">
                        <img src="images/icon_03.png" className="img-fluid mr-3"/>
                        <span>２．適正管理</span>
                    </h2>
                    <div className="description-item-parts">
                        弊社は、お客さまの個人情報への不正なアクセスや漏洩等を防ぐため、セキュリティーの維持に努めます。
                    </div>
                    <h2 className="h2-tag-parts">
                        <img src="images/icon_03.png" className="img-fluid mr-3"/>
                        <span>３．第三者への開示</span>
                    </h2>
                    <div className="description-item-parts">
                        弊社はお客さまから承諾を得ている場合を除き、第三者にお客さまの個人情報を提供または開示しません。但し、お客さまの個人情報を第１項の目的のため、弊社がDMの発送やメール配信等の業務を委託するため委託先に開示する場合及び法令に基づく開示など正当な理由がある場合にはこの限りではありません。
                    </div>
                    <h2 className="h2-tag-parts">
                        <img src="images/icon_03.png" className="img-fluid mr-3"/>
                        <span>４．委託先等の管理</span>
                    </h2>
                    <div className="description-item-parts">
                        弊社は前項によりお客さまの個人情報を提供又は開示する委託先に対し、適切な取扱い及び保護を行わせ、第三者への開示・提供又は第１項の目的以外の利用を禁止します。
                    </div>
                    <h2 className="h2-tag-parts">
                        <img src="images/icon_03.png" className="img-fluid mr-3"/>
                        <span>５．情報提供の停止</span>
                    </h2>
                    <div className="description-item-parts">
                        弊社の商品やサービス等に関する情報の提供が不要な場合には、その旨をご連絡いただければ、提供を中止いたします。
                    </div>
                    <h2 className="h2-tag-parts">
                        <img src="images/icon_03.png" className="img-fluid mr-3"/>
                        <span>６．開示・訂正等</span>
                    </h2>
                    <div className="description-item-parts">
                        お客さまがご自身の個人情報の内容を確認又は訂正を希望される場合には、ご連絡いただければ、合理的な範囲で速やかに対応させていただきます。
                    </div>
                    <h2 className="h2-tag-parts">
                        <img src="images/icon_03.png" className="img-fluid mr-3"/>
                        <span>７．改善</span>
                    </h2>
                    <div className="description-item-parts">
                        弊社は、お客さまの個人情報の取扱いに関する法令等を遵守するとともに、本ポリシーを適宜見直し、改善を図ってまいります。従って、本ポリシーが予告無しに変更されることがありますことを予めご了承ください。
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
)

export default Privacy